// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8ed1a53","453":"27b9373e","455":"cd057aa5","977":"7ec1d96f"}[chunkId] + ".chunk.js";
};